<template>
  <div class="lateral-sliding">
    <div class="lateral-sliding-item" v-for="(item,index) in dates" :key="index">
      <div class="each-box">
        <div class="each-text" :class="index==currentDateIndex?'each-text-active':''" @click="changDate(index)">
          <div style="padding-top: .12rem">{{item.label}}</div>
          <div style="padding-top: .02rem">{{item.value}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      props:{
        cIndex:{
          type:Number,
          default:0
        },
      },
      data(){
        return{
          dates:[],
          currentDateIndex:0
        }
      },
      created() {
        this.currentDateIndex = this.cIndex
        //存储今天后14天日期
        let date14 = []
        for(let i=1;i<14;i++){
          date14.push(this.getDateStr(i))
        }
        //设置今天的日期
        this.dates.push({label:this.getDateWeek(new Date()),value:'今天',date:this.getDateYYMMDD(new Date()),index:0})
        //设置今天后14天的日期
        for(let i=0;i<date14.length;i++){
          this.dates.push({
            label:this.getDateWeek(date14[i]),
            value:this.getDateMMDD(date14[i]),
            date:this.getDateYYMMDD(date14[i]),
            index:i+1
          })
        }
      },
      methods:{
        changDate(index){
          //防重复
          if(this.currentDateIndex != index){
            this.currentDateIndex = index
            this.$emit('changDate',this.dates[index])
          }
        },
        //获取AddDayCount天后的日期
        getDateStr(AddDayCount) {
          let dd = new Date();
          dd.setDate(dd.getDate()+AddDayCount);//获取AddDayCount天后的日期
          let y = dd.getFullYear();
          let m = (dd.getMonth()+1)<10?"0"+(dd.getMonth()+1):(dd.getMonth()+1);//获取当前月份的日期，不足10补0
          let d = dd.getDate()<10?"0"+dd.getDate():dd.getDate();//获取当前几号，不足10补0
          return y+"-"+m+"-"+d;
        },
        //获取date的星期几
        getDateWeek(date){
          let myDate = new Date(date)
          let wk = myDate.getDay()
          let weeks = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
          let week = weeks[wk]
          return week
        },
        //获取date的月-日
        getDateMMDD(date){
          let myDate = new Date(date)
          let mm = String((myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1))
          let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
          return mm + '-' + dd
        },
        //获取date的年-月-日
        getDateYYMMDD(date){
          let myDate = new Date(date)
          let yy = myDate.getFullYear();
          let mm = String((myDate.getMonth() + 1) < 10 ? '0' + (myDate.getMonth() + 1) : (myDate.getMonth() + 1))
          let dd = String(myDate.getDate() < 10 ? '0' + myDate.getDate() : myDate.getDate())
          return yy + '-' +mm + '-' + dd
        },
      }
    }
</script>

<style scoped>
  .lateral-sliding {
    display: flex;
    overflow-y: hidden;
    overflow-x: scroll;
    border-bottom: 1px #f0f0f0 solid;
  }
  .lateral-sliding-item {
    display: flex;
  }
  .each-box{
    width: 1.5rem;
    height: 1.2rem;
  }
  .each-text {
    font-size: .26rem;
    margin: .1rem auto;
    width: 80%;
    height: 1rem;
    text-align: center;
  }
  .each-text-active{
    background-color: #409eff;
    color: #ffffff;
    border-radius: .1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/DateTabs.vue